import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ThirdFloorDataGrid from '../Grids';


const ReportData = ( { contacts, loans, opps, tasks, selectedReport, data, schema } ) => {
    if ( !selectedReport || selectedReport.showRawData === false || !schema ) {
        return null;
    }

    return (
        <Container fluid>
            <Row>
                <Col className='fw-bold'>Raw Data</Col>
            </Row>
            <Row style={ { height: '400px' } }>
                <ThirdFloorDataGrid 
                    gridKey={selectedReport.id} 
                    schema={schema} 
                    rows={data} 
                    pageRegistry={ {} } 
                    helperContext={ {
                        contacts
                    } }
                    overrides={ {} }
                />  
            </Row>
        </Container>
                    
    );
}

const mapProps = ( state ) => ( {
    contacts: state.contacts.byId,
    loans: state.loans.byId,
    opps: state.leadopps.byId,
    tasks: state.tasks.byId,
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( ReportData );